import { PropTypes } from 'prop-types'
import { connect } from 'react-redux';

import React, { Suspense, lazy } from 'react'
import { Router, Switch, Route } from "react-router-dom";
import history from './components/hooks/history'
import AppBarPrimary from './components/AppBarPrimary';
import Footer from './components/Footer';
import HomeScreen from './components/screens/HomeScreen';
import { Action_user_login_passport } from './store/action/action-user'
import DashboardScreen from './components/screens/private/DashboardScreen'
import { Action_LoginsOpener } from './store/action/Action-ALL'
import PrivateRoute from './components/auth/PrivateRoute'
import Logins from './components/auth/Logins'
import MsgScreen from './components/screens/MsgScreen'
import Modal_Hook from './components/hooks/Modal_Hook'


import NewProductScreen from './components/screens/seller/NewProductScreen'
import UsersManagementScreen from './components/screens/admin/UsersManagementScreen'

import UserOrdersScreen from './components/screens/private/UserOrdersScreen'
// const UserOrdersScreen = lazy(() => import('./components/screens/private/UserOrdersScreen'))

// const AboutScreen = lazy(() => import('./components/screens/AboutScreen'));
import AboutScreen from './components/screens/AboutScreen';

import SideMenuDrawer from './components/SideMenuDrawer'
// const SideMenuDrawer = lazy(() => import( './components/SideMenuDrawer'))

import LoggedOutScreen from './components/screens/auth/LoggedOutScreen';
import PasswordGate from './providers/PasswordGate';
// const LoggedOutScreen = lazy(() => import('./components/screens/auth/LoggedOutScreen'));

// import ErrorContainer from './components/containers/ErrorContainer';
// import {Action_MessageModalOpener} from './store/action/Action-ALL'


class App extends React.Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isOpen: false
  //   }
  // }

  componentDidMount() {
    this.props.Action_user_login_passport()
  }


  render() {

    return (
      <PasswordGate>
        <Suspense fallback={<h1>Loading...</h1>}>
          <Router history={history}>
            <div className="grid-container">
              <AppBarPrimary />

              <div className='headerBanner'  >
                <img src="/appImgs/black-friday-9.jpg" alt="promotions" />


                {/* 
            <button onClick={() => {
              this.setState({ isOpen: !this.state.isOpen })

            }}>
              isOpen
            </button> */}





              </div>

              <main>
                <SideMenuDrawer />

                <Switch>
                  <Route path="/about">
                    <AboutScreen history={history} />
                  </Route>



                  <Route path="/profile">
                    <DashboardScreen />
                  </Route>


                  <Route path="/logout">
                    <LoggedOutScreen />
                  </Route>

                  <Route path="/MsgScreen">
                    <MsgScreen msg='' />
                  </Route>

                  <PrivateRoute path="/UserOrdersScreen">
                    <UserOrdersScreen />
                  </PrivateRoute>


                  <PrivateRoute actor="seller" path="/seller/NewProductScreen">
                    <NewProductScreen />
                  </PrivateRoute>

                  <PrivateRoute actor="admin" path="/admin/UsersManagementScreen">
                    <UsersManagementScreen />
                  </PrivateRoute>



                  <Route path="/">
                    <HomeScreen history={history} />
                  </Route>

                  <Route path="*" exact={true}>
                    <AboutScreen history={history} />
                  </Route>
                  <Route component={AboutScreen} />


                </Switch>



                {/* LOGIN MODAL */}
                <Modal_Hook
                  body={<Logins />}
                  isOpen={this.props.isLoginsOpen}
                  handleClose={() => this.props.Action_LoginsOpener(false)} />



              </main>
              <Footer />
            </div>
          </Router>
        </Suspense>
      </PasswordGate>
    );

  }
}

App.propTypes = {
  isLoginsOpen: PropTypes.bool,
  Action_LoginsOpener: PropTypes.func,
  msgModal: PropTypes.object,
  Action_user_login_passport: PropTypes.func,
  // Action_MessageModalOpener:PropTypes.func,
}

export default connect((state) => ({
  isLoginsOpen: state.reducer_ALL.isLoginsOpen,
}),
  {
    Action_LoginsOpener,
    Action_user_login_passport,

    // Action_MessageModalOpener
  }
)(App)